import { DashboardFeatureId } from '../AdviserArea/AdviserArea.types';
import { OnboardingWorkflow } from '../CommonSelectors/CommonArea.types';
import { ModelGroupDTO } from './api/useModelPortfolioGroupsQuery';
import { OptionType } from '../CommonComponents/OPL/Select/BaseSelect/types';

interface OnboardingWorkflowOption {
  label: string;
  value: OnboardingWorkflow;
}

export enum LandingPage {
  Overview = 0,
  GoalResults = 1,
  PersonalFinances = 2,
  Profile = 3,
  Reports = 4,
  DocumentVault = 5,
  Newsfeed = 7,
  AssetBucketing = 8,
  BeFi20 = 9,
  PersonalFinancesSummary = 10,
  PersonalFinancesPositions = 11,
  PersonalFinancesNetWorth = 12,
  PulseCheck = 13,
}

export enum BehavioralFinanceTools {
  AssetBucketing = 11,
  BeFi20 = 12,
  Rtq = 13,
  PulseCheck = 14,
}

export interface ClientAccessDTO {
  CurrentOnboardingWorkflow: OnboardingWorkflow | null;
  DashboardAccessSet: DashboardFeatureId[] | null;
  DefaultDashboardAccessSet: DashboardFeatureId[];
  LinkAccountsAccess: boolean;
  DataReconciliationAccess: boolean;
  ClientLandingPage: LandingPage | null;
  DefaultClientLandingPage: LandingPage;
  ClientLandingPageOptions: OptionType<LandingPage>[];
  LastCompletedOnboardingDate: string;
  LastCompletedOnboardingName: string;
  ShowProBono: boolean;
  IsProBonoClient: boolean;
  TaxableAccountModelGroup: ModelGroupDTO | null;
  NonTaxableAccountModelGroup: ModelGroupDTO | null;
  FullyAutomatedAccountOpening: boolean;
  AgreementOptions: { Label: string; Value: string }[];
  SelectedAgreements: string[] | null;
  IsPreviewLinkEnabled: boolean;
  OnboardingWorkflowOptions: OnboardingWorkflowOption[];
  CanAddManualAccount: boolean | null;
  DisplayAddManualAccountToggle: boolean;
  HasOrionReportsEnabled: boolean;
  DisplayMobileAppPushNotificationsSection: boolean | null;
  AllowMobileAppPushNotifications: boolean | null;
  DefaultDocumentUploadMobilePushNotifications: boolean | null;
  DefaultNewsfeedMobilePushNotifications: boolean | null;
  HasDocumentVaultFirm: boolean;
  IsNewsfeedEnabledOnOC: boolean;
  DisplayBehavioralFinanceSection: boolean;
  HiddenBeFiTools: BehavioralFinanceTools[];
}

export interface ClientAccessSettingsState {
  dashboardAccess: DashboardFeatureId[] | null;
  onboardingWorkflow: OnboardingWorkflow | null;
  linkAccountsAccess: boolean;
  dataReconciliationAccess: boolean;
  isProBonoClient: boolean;
  taxableAccountModelGroup: ModelGroupDTO | null;
  nonTaxableAccountModelGroup: ModelGroupDTO | null;
  fullyAutomatedAccountOpening: boolean;
  clientLandingPage: LandingPage | null;
  selectedAgreements: string[] | null;
  canAddManualAccount: boolean;
  allowMobileAppPushNotifications: boolean;
  defaultDocumentUploadMobilePushNotifications: boolean;
  defaultNewsfeedMobilePushNotifications: boolean;
}

export interface ClientAccessData extends ClientAccessSettingsState {
  defaultClientLandingPage: LandingPage;
  defaultDashboardAccessSet: DashboardFeatureId[];
  clientLandingPageOptions: OptionType<LandingPage>[];
  onboardingWorkflowOptions: OnboardingWorkflowOption[];
  completedOnboardingMessage: string | null;
  showProBono: boolean;
  agreementOptions: OptionType<string>[];
  isLoadingAgreementOptions?: boolean;
  isPreviewLinkEnabled: boolean;
  displayAddManualAccountToggle: boolean;
  hasOrionReportsEnabled: boolean;
  displayMobileAppPushNotificationsSection: boolean;
  defaultDocumentUploadMobilePushNotifications: boolean;
  defaultNewsfeedMobilePushNotifications: boolean;
  allowMobileAppPushNotifications: boolean;
  hasDocumentVaultFirm: boolean;
  isNewsfeedEnabledOnOC: boolean;
  displayBehavioralFinanceSection: boolean;
  hiddenBeFiTools: BehavioralFinanceTools[];
}

export interface ClientAccessSettingsProps extends Partial<ClientAccessData> {
  dashboardAccess: DashboardFeatureId[] | null;
  onboardingWorkflow: OnboardingWorkflow | null;
  onboardingWorkflowOptions: OnboardingWorkflowOption[];
  showDataAggregation?: boolean;
  showDataReconciliation?: boolean;
  showBeFi20?: boolean;
  clientId?: string;
  onChange(data: Partial<ClientAccessSettingsState>): void;
}

export interface SaveParams {
  isSaveAndPreview?: boolean;
  onSuccess?: () => void;
}
